import axios from 'axios';

export class FlagsSprite {
  private readonly FLAGS_SPRITE_PATH: string = 'https://assets.nsoft.app/sports-flags/sprite.zst';

  async load() {
    try {
      const svgSpriteEl: SVGElement | null = document.querySelector('#flags-sprite');
      if (svgSpriteEl)
        svgSpriteEl.innerHTML = (await axios({ method: 'GET', url: this.FLAGS_SPRITE_PATH })).data;
    } catch (error) {
      console.log('Error occured while parsing SVG content. Error: ', error);
    }
  }
}
